import styled from "styled-components";

const AboutUs = () => {
  return (
    <div>
      <TopDiv>
        <h1>About Us</h1>
        <p>
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Inventore
          velit aut nisi vitae et! Dolores debitis incidunt nulla eius hic
          possimus dolor quibusdam in porro, qui totam ad maxime quos illo,
          iusto saepe quidem tempore id voluptatum dicta obcaecati repellendus.
          Odit commodi blanditiis cupiditate iste laudantium iure fugit labore
          eveniet!
        </p>
      </TopDiv>
      <BottomDiv>
        <AboutUsCard>
          <img src="/img/Mask Group 17.png" alt="" />
          <p>
            Lorem ipsum dolor sit, amet consectetur adipisicing elit.
            Voluptatem, nulla!
          </p>
        </AboutUsCard>
        <AboutUsCard>
          <img src="/img/Mask Group 18.png" alt="" />
          <p>
            Lorem ipsum dolor sit, amet consectetur adipisicing elit.
            Voluptatem, nulla!
          </p>
        </AboutUsCard>
        <AboutUsCard>
          <img src="/img/Mask Group 19.png" alt="" />
          <p>
            Lorem ipsum dolor sit, amet consectetur adipisicing elit.
            Voluptatem, nulla!
          </p>
        </AboutUsCard>
      </BottomDiv>
      <StayConnectedDiv>
        <p>Stay Connected with us</p>
        <img src="/img/Path 49406.svg" alt="" />
        <SocialDiv>
          <img src="/img/facebook.svg" alt="" />
          <img src="/img/linkedin.svg" alt="" />
          <img src="/img/twitter.svg" alt="" />
        </SocialDiv>
      </StayConnectedDiv>
      <ButtonGroup>
        <Button className="btn">Book Consultation With Top Doctors</Button>
        <Button className="btn">Know More About Us</Button>
        <Button className="btn">How to Contact Us</Button>
      </ButtonGroup>
    </div>
  );
};

const Button = styled.div`
  border-radius: 50px;
  border: 2px solid #01d6c0;
  padding: 1% 3%;
  font-weight: 600;
  color: white;
  &:hover {
    background-color: #01d6c0;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-evenly;
  padding: 3% 0;
  background-color: #0d233f;
  color: white;
`;

const SocialDiv = styled.div`
  display: flex;
  & > img {
    margin-inline: 5%;
  }
`;

const StayConnectedDiv = styled.div`
  display: flex;
  margin: 2% 4%;
  align-items: center;
  justify-content: space-between;

  & > p {
    font-weight: 600;
    letter-spacing: 1px;
    font-size: 1.5rem;
    margin: 0;
  }
`;

const AboutUsCard = styled.div`
  margin-top: -8%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  & > p {
    margin-top: 5%;
    color: #707070;
  }
  & > img {
    height: 10rem;
    width: 10rem;
  }
`;

const TopDiv = styled.div`
  padding: 2% 6% 10%;
  background-color: #0d233f;
  color: white;
  text-align: center;

  & > h1 {
    font-weight: 600;
  }
  & > p {
    color: #ccd0d2;
    margin-top: 2%;
  }
`;

const BottomDiv = styled.div`
  margin-inline: 4%;
  display: flex;
  justify-content: space-around;
`;

export default AboutUs;
